"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var thumb = {
  appearance: 'none !important',
  width: 10,
  height: 10,
  background: '#fff',
  borderRadius: '50%',
  border: 0,
  boxShadow: '0 1px 1px 0 rgba(0, 0, 0, 0.16);',
  cursor: 'pointer'
};
var track = {
  width: '100%',
  height: 4,
  borderRadius: 6,
  background: '#dddddd'
};
var progress = {
  background: '#2dd79a',
  height: 4,
  borderRadius: 6
};
var _default = {
  Input: {
    width: '100%',
    background: 'transparent',
    '-webkit-appearance': 'none',
    '&::-moz-range-thumb': thumb,
    '&::-webkit-slider-thumb': _objectSpread(_objectSpread({}, thumb), {}, {
      marginTop: '-2px'
    }),
    '&::-moz-range-track': track,
    '&::-webkit-slider-runnable-track': track,
    '&::-moz-range-progress': progress,
    '&::-webkit-progress-value': progress
  }
};
exports["default"] = _default;
//# sourceMappingURL=style.js.map